/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DoorRouteImport } from './routes/$door'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as LiveRouteImport } from './routes/live'
import { Route as LotsRouteImport } from './routes/lots'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ReservationsRouteImport } from './routes/reservations'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as InventoryIndexRouteImport } from './routes/inventory.index'
import { Route as InventoryIdRouteImport } from './routes/inventory.$id'
import { Route as InventoryBulkRouteImport } from './routes/inventory.bulk'
import { Route as InventoryCreateRouteImport } from './routes/inventory.create'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as LotsIndexRouteImport } from './routes/lots.index'
import { Route as LotsIdRouteImport } from './routes/lots.$id'
import { Route as LotsCreateRouteImport } from './routes/lots.create'
import { Route as LotsEbayImportRouteImport } from './routes/lots.ebay-import'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsIdRouteImport } from './routes/products.$id'
import { Route as ProductsCreateRouteImport } from './routes/products.create'
import { Route as ProductsDeckImportRouteImport } from './routes/products.deck-import'
import { Route as ProductsPickRouteImport } from './routes/products.pick'
import { Route as ProductsStudioRouteImport } from './routes/products.studio'
import { Route as SalesIndexRouteImport } from './routes/sales.index'
import { Route as SalesIdRouteImport } from './routes/sales.$id'
import { Route as SalesCreateRouteImport } from './routes/sales.create'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAccountSecurityRouteImport } from './routes/settings.account-security'
import { Route as SettingsBundleDefaultsRouteImport } from './routes/settings.bundle-defaults'
import { Route as SettingsDisplayRouteImport } from './routes/settings.display'
import { Route as SettingsEbayRouteImport } from './routes/settings.ebay'
import { Route as SettingsListingTemplatesRouteImport } from './routes/settings.listing-templates'
import { Route as SettingsStoreOptionsRouteImport } from './routes/settings.store-options'
import { Route as SettingsUserManagementRouteImport } from './routes/settings.user-management'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopAccountRouteImport } from './routes/shop.account'
import { Route as ShopCartRouteImport } from './routes/shop.cart'
import { Route as ShopInventoryRouteImport } from './routes/shop.inventory'
import { Route as ShopJoinRouteImport } from './routes/shop.join'
import { Route as ShopPrivacyRouteImport } from './routes/shop.privacy'
import { Route as ShopReserveRouteImport } from './routes/shop.reserve'
import { Route as ShopSoldRouteImport } from './routes/shop.sold'
import { Route as ShopTermsRouteImport } from './routes/shop.terms'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsAnalyticsRouteImport } from './routes/tools.analytics'
import { Route as ToolsBreakevenRouteImport } from './routes/tools.breakeven'
import { Route as ToolsBundleSettingsRouteImport } from './routes/tools.bundle-settings'
import { Route as ToolsBundleTemplateEditRouteImport } from './routes/tools.bundle-template-edit'
import { Route as ToolsBundleTemplatesRouteImport } from './routes/tools.bundle-templates'
import { Route as ToolsCostbasisBackfillRouteImport } from './routes/tools.costbasis-backfill'
import { Route as ToolsDeckSearchRouteImport } from './routes/tools.deck-search'
import { Route as ToolsDeckTemplatesRouteImport } from './routes/tools.deck-templates'
import { Route as ToolsEbayRouteImport } from './routes/tools.ebay'
import { Route as ToolsImportRouteImport } from './routes/tools.import'
import { Route as ToolsIntakeRouteImport } from './routes/tools.intake'
import { Route as ToolsLeadsRouteImport } from './routes/tools.leads'
import { Route as ToolsListingImportRouteImport } from './routes/tools.listing-import'
import { Route as ToolsLocateRouteImport } from './routes/tools.locate'
import { Route as ToolsLotAnalyzerRouteImport } from './routes/tools.lot-analyzer'
import { Route as ToolsPricetrackRouteImport } from './routes/tools.pricetrack'
import { Route as ToolsRecommendationsRouteImport } from './routes/tools.recommendations'
import { Route as ToolsReportsRouteImport } from './routes/tools.reports'
import { Route as ToolsRoiRouteImport } from './routes/tools.roi'
import { Route as ToolsScanRouteImport } from './routes/tools.scan'
import { Route as ToolsSetmanagerRouteImport } from './routes/tools.setmanager'
import { Route as ToolsStorageBinsRouteImport } from './routes/tools.storage-bins'
import { Route as ToolsSuppliesRouteImport } from './routes/tools.supplies'
import { Route as ToolsTemplatesRouteImport } from './routes/tools.templates'
import { Route as ToolsWeightRouteImport } from './routes/tools.weight'
import { Route as SalesIdIndexRouteImport } from './routes/sales.$id.index'
import { Route as SalesIdPickRouteImport } from './routes/sales.$id.pick'
import { Route as ShopAccountIndexRouteImport } from './routes/shop.account.index'
import { Route as ShopAccountLoginRouteImport } from './routes/shop.account.login'
import { Route as ShopAccountVerifyRouteImport } from './routes/shop.account.verify'
import { Route as ShopBundleIdRouteImport } from './routes/shop.bundle.$id'
import { Route as ShopCardIdRouteImport } from './routes/shop.card.$id'
import { Route as ShopRTokenRouteImport } from './routes/shop.r.$token'
import { Route as ToolsImportsIndexRouteImport } from './routes/tools.imports.index'
import { Route as ToolsImportsIdRouteImport } from './routes/tools.imports.$id'
import { Route as ToolsImportsNewRouteImport } from './routes/tools.imports.new'
import { Route as ShopAccountReservationsIdRouteImport } from './routes/shop.account.reservations.$id'
import { Route as ToolsImportsIdIndexRouteImport } from './routes/tools.imports.$id.index'
import { Route as ToolsImportsIdResultsRouteImport } from './routes/tools.imports.$id.results'
import { Route as ToolsImportsIdReviewRouteImport } from './routes/tools.imports.$id.review'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DoorRoute = DoorRouteImport.update({
  id: '/$door',
  path: '/$door',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveRoute = LiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => rootRouteImport,
} as any)
const LotsRoute = LotsRouteImport.update({
  id: '/lots',
  path: '/lots',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservationsRoute = ReservationsRouteImport.update({
  id: '/reservations',
  path: '/reservations',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesRoute = SalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopRoute = ShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsRoute = ToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InventoryRoute,
} as any)
const InventoryIdRoute = InventoryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InventoryRoute,
} as any)
const InventoryBulkRoute = InventoryBulkRouteImport.update({
  id: '/bulk',
  path: '/bulk',
  getParentRoute: () => InventoryRoute,
} as any)
const InventoryCreateRoute = InventoryCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => InventoryRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LotsIndexRoute = LotsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LotsRoute,
} as any)
const LotsIdRoute = LotsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LotsRoute,
} as any)
const LotsCreateRoute = LotsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => LotsRoute,
} as any)
const LotsEbayImportRoute = LotsEbayImportRouteImport.update({
  id: '/ebay-import',
  path: '/ebay-import',
  getParentRoute: () => LotsRoute,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsIdRoute = ProductsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsCreateRoute = ProductsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsDeckImportRoute = ProductsDeckImportRouteImport.update({
  id: '/deck-import',
  path: '/deck-import',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsPickRoute = ProductsPickRouteImport.update({
  id: '/pick',
  path: '/pick',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsStudioRoute = ProductsStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => ProductsRoute,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesRoute,
} as any)
const SalesIdRoute = SalesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SalesRoute,
} as any)
const SalesCreateRoute = SalesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => SalesRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountSecurityRoute = SettingsAccountSecurityRouteImport.update({
  id: '/account-security',
  path: '/account-security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBundleDefaultsRoute = SettingsBundleDefaultsRouteImport.update({
  id: '/bundle-defaults',
  path: '/bundle-defaults',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDisplayRoute = SettingsDisplayRouteImport.update({
  id: '/display',
  path: '/display',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEbayRoute = SettingsEbayRouteImport.update({
  id: '/ebay',
  path: '/ebay',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsListingTemplatesRoute =
  SettingsListingTemplatesRouteImport.update({
    id: '/listing-templates',
    path: '/listing-templates',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsStoreOptionsRoute = SettingsStoreOptionsRouteImport.update({
  id: '/store-options',
  path: '/store-options',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUserManagementRoute = SettingsUserManagementRouteImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => SettingsRoute,
} as any)
const ShopIndexRoute = ShopIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShopRoute,
} as any)
const ShopAccountRoute = ShopAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ShopRoute,
} as any)
const ShopCartRoute = ShopCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => ShopRoute,
} as any)
const ShopInventoryRoute = ShopInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => ShopRoute,
} as any)
const ShopJoinRoute = ShopJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => ShopRoute,
} as any)
const ShopPrivacyRoute = ShopPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => ShopRoute,
} as any)
const ShopReserveRoute = ShopReserveRouteImport.update({
  id: '/reserve',
  path: '/reserve',
  getParentRoute: () => ShopRoute,
} as any)
const ShopSoldRoute = ShopSoldRouteImport.update({
  id: '/sold',
  path: '/sold',
  getParentRoute: () => ShopRoute,
} as any)
const ShopTermsRoute = ShopTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => ShopRoute,
} as any)
const ToolsIndexRoute = ToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsAnalyticsRoute = ToolsAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsBreakevenRoute = ToolsBreakevenRouteImport.update({
  id: '/breakeven',
  path: '/breakeven',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsBundleSettingsRoute = ToolsBundleSettingsRouteImport.update({
  id: '/bundle-settings',
  path: '/bundle-settings',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsBundleTemplateEditRoute = ToolsBundleTemplateEditRouteImport.update({
  id: '/bundle-template-edit',
  path: '/bundle-template-edit',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsBundleTemplatesRoute = ToolsBundleTemplatesRouteImport.update({
  id: '/bundle-templates',
  path: '/bundle-templates',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsCostbasisBackfillRoute = ToolsCostbasisBackfillRouteImport.update({
  id: '/costbasis-backfill',
  path: '/costbasis-backfill',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsDeckSearchRoute = ToolsDeckSearchRouteImport.update({
  id: '/deck-search',
  path: '/deck-search',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsDeckTemplatesRoute = ToolsDeckTemplatesRouteImport.update({
  id: '/deck-templates',
  path: '/deck-templates',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsEbayRoute = ToolsEbayRouteImport.update({
  id: '/ebay',
  path: '/ebay',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsImportRoute = ToolsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsIntakeRoute = ToolsIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsLeadsRoute = ToolsLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsListingImportRoute = ToolsListingImportRouteImport.update({
  id: '/listing-import',
  path: '/listing-import',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsLocateRoute = ToolsLocateRouteImport.update({
  id: '/locate',
  path: '/locate',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsLotAnalyzerRoute = ToolsLotAnalyzerRouteImport.update({
  id: '/lot-analyzer',
  path: '/lot-analyzer',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsPricetrackRoute = ToolsPricetrackRouteImport.update({
  id: '/pricetrack',
  path: '/pricetrack',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsRecommendationsRoute = ToolsRecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsReportsRoute = ToolsReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsRoiRoute = ToolsRoiRouteImport.update({
  id: '/roi',
  path: '/roi',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsScanRoute = ToolsScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsSetmanagerRoute = ToolsSetmanagerRouteImport.update({
  id: '/setmanager',
  path: '/setmanager',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsStorageBinsRoute = ToolsStorageBinsRouteImport.update({
  id: '/storage-bins',
  path: '/storage-bins',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsSuppliesRoute = ToolsSuppliesRouteImport.update({
  id: '/supplies',
  path: '/supplies',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsTemplatesRoute = ToolsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsWeightRoute = ToolsWeightRouteImport.update({
  id: '/weight',
  path: '/weight',
  getParentRoute: () => ToolsRoute,
} as any)
const SalesIdIndexRoute = SalesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesIdRoute,
} as any)
const SalesIdPickRoute = SalesIdPickRouteImport.update({
  id: '/pick',
  path: '/pick',
  getParentRoute: () => SalesIdRoute,
} as any)
const ShopAccountIndexRoute = ShopAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShopAccountRoute,
} as any)
const ShopAccountLoginRoute = ShopAccountLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => ShopAccountRoute,
} as any)
const ShopAccountVerifyRoute = ShopAccountVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => ShopAccountRoute,
} as any)
const ShopBundleIdRoute = ShopBundleIdRouteImport.update({
  id: '/bundle/$id',
  path: '/bundle/$id',
  getParentRoute: () => ShopRoute,
} as any)
const ShopCardIdRoute = ShopCardIdRouteImport.update({
  id: '/card/$id',
  path: '/card/$id',
  getParentRoute: () => ShopRoute,
} as any)
const ShopRTokenRoute = ShopRTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => ShopRoute,
} as any)
const ToolsImportsIndexRoute = ToolsImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsImportsIdRoute = ToolsImportsIdRouteImport.update({
  id: '/imports/$id',
  path: '/imports/$id',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsImportsNewRoute = ToolsImportsNewRouteImport.update({
  id: '/imports/new',
  path: '/imports/new',
  getParentRoute: () => ToolsRoute,
} as any)
const ShopAccountReservationsIdRoute =
  ShopAccountReservationsIdRouteImport.update({
    id: '/reservations/$id',
    path: '/reservations/$id',
    getParentRoute: () => ShopAccountRoute,
  } as any)
const ToolsImportsIdIndexRoute = ToolsImportsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ToolsImportsIdRoute,
} as any)
const ToolsImportsIdResultsRoute = ToolsImportsIdResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => ToolsImportsIdRoute,
} as any)
const ToolsImportsIdReviewRoute = ToolsImportsIdReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => ToolsImportsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$door': typeof DoorRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRouteWithChildren
  '/live': typeof LiveRoute
  '/lots': typeof LotsRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/reservations': typeof ReservationsRoute
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/shop': typeof ShopRouteWithChildren
  '/tools': typeof ToolsRouteWithChildren
  '/inventory/$id': typeof InventoryIdRoute
  '/inventory/bulk': typeof InventoryBulkRoute
  '/inventory/create': typeof InventoryCreateRoute
  '/join/$token': typeof JoinTokenRoute
  '/lots/$id': typeof LotsIdRoute
  '/lots/create': typeof LotsCreateRoute
  '/lots/ebay-import': typeof LotsEbayImportRoute
  '/products/$id': typeof ProductsIdRoute
  '/products/create': typeof ProductsCreateRoute
  '/products/deck-import': typeof ProductsDeckImportRoute
  '/products/pick': typeof ProductsPickRoute
  '/products/studio': typeof ProductsStudioRoute
  '/sales/$id': typeof SalesIdRouteWithChildren
  '/sales/create': typeof SalesCreateRoute
  '/settings/account-security': typeof SettingsAccountSecurityRoute
  '/settings/bundle-defaults': typeof SettingsBundleDefaultsRoute
  '/settings/display': typeof SettingsDisplayRoute
  '/settings/ebay': typeof SettingsEbayRoute
  '/settings/listing-templates': typeof SettingsListingTemplatesRoute
  '/settings/store-options': typeof SettingsStoreOptionsRoute
  '/settings/user-management': typeof SettingsUserManagementRoute
  '/shop/account': typeof ShopAccountRouteWithChildren
  '/shop/cart': typeof ShopCartRoute
  '/shop/inventory': typeof ShopInventoryRoute
  '/shop/join': typeof ShopJoinRoute
  '/shop/privacy': typeof ShopPrivacyRoute
  '/shop/reserve': typeof ShopReserveRoute
  '/shop/sold': typeof ShopSoldRoute
  '/shop/terms': typeof ShopTermsRoute
  '/tools/analytics': typeof ToolsAnalyticsRoute
  '/tools/breakeven': typeof ToolsBreakevenRoute
  '/tools/bundle-settings': typeof ToolsBundleSettingsRoute
  '/tools/bundle-template-edit': typeof ToolsBundleTemplateEditRoute
  '/tools/bundle-templates': typeof ToolsBundleTemplatesRoute
  '/tools/costbasis-backfill': typeof ToolsCostbasisBackfillRoute
  '/tools/deck-search': typeof ToolsDeckSearchRoute
  '/tools/deck-templates': typeof ToolsDeckTemplatesRoute
  '/tools/ebay': typeof ToolsEbayRoute
  '/tools/import': typeof ToolsImportRoute
  '/tools/intake': typeof ToolsIntakeRoute
  '/tools/leads': typeof ToolsLeadsRoute
  '/tools/listing-import': typeof ToolsListingImportRoute
  '/tools/locate': typeof ToolsLocateRoute
  '/tools/lot-analyzer': typeof ToolsLotAnalyzerRoute
  '/tools/pricetrack': typeof ToolsPricetrackRoute
  '/tools/recommendations': typeof ToolsRecommendationsRoute
  '/tools/reports': typeof ToolsReportsRoute
  '/tools/roi': typeof ToolsRoiRoute
  '/tools/scan': typeof ToolsScanRoute
  '/tools/setmanager': typeof ToolsSetmanagerRoute
  '/tools/storage-bins': typeof ToolsStorageBinsRoute
  '/tools/supplies': typeof ToolsSuppliesRoute
  '/tools/templates': typeof ToolsTemplatesRoute
  '/tools/weight': typeof ToolsWeightRoute
  '/inventory/': typeof InventoryIndexRoute
  '/lots/': typeof LotsIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shop/': typeof ShopIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/sales/$id/pick': typeof SalesIdPickRoute
  '/shop/account/login': typeof ShopAccountLoginRoute
  '/shop/account/verify': typeof ShopAccountVerifyRoute
  '/shop/bundle/$id': typeof ShopBundleIdRoute
  '/shop/card/$id': typeof ShopCardIdRoute
  '/shop/r/$token': typeof ShopRTokenRoute
  '/tools/imports/$id': typeof ToolsImportsIdRouteWithChildren
  '/tools/imports/new': typeof ToolsImportsNewRoute
  '/sales/$id/': typeof SalesIdIndexRoute
  '/shop/account/': typeof ShopAccountIndexRoute
  '/tools/imports/': typeof ToolsImportsIndexRoute
  '/shop/account/reservations/$id': typeof ShopAccountReservationsIdRoute
  '/tools/imports/$id/results': typeof ToolsImportsIdResultsRoute
  '/tools/imports/$id/review': typeof ToolsImportsIdReviewRoute
  '/tools/imports/$id/': typeof ToolsImportsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$door': typeof DoorRoute
  '/dashboard': typeof DashboardRoute
  '/live': typeof LiveRoute
  '/reservations': typeof ReservationsRoute
  '/inventory/$id': typeof InventoryIdRoute
  '/inventory/bulk': typeof InventoryBulkRoute
  '/inventory/create': typeof InventoryCreateRoute
  '/join/$token': typeof JoinTokenRoute
  '/lots/$id': typeof LotsIdRoute
  '/lots/create': typeof LotsCreateRoute
  '/lots/ebay-import': typeof LotsEbayImportRoute
  '/products/$id': typeof ProductsIdRoute
  '/products/create': typeof ProductsCreateRoute
  '/products/deck-import': typeof ProductsDeckImportRoute
  '/products/pick': typeof ProductsPickRoute
  '/products/studio': typeof ProductsStudioRoute
  '/sales/create': typeof SalesCreateRoute
  '/settings/account-security': typeof SettingsAccountSecurityRoute
  '/settings/bundle-defaults': typeof SettingsBundleDefaultsRoute
  '/settings/display': typeof SettingsDisplayRoute
  '/settings/ebay': typeof SettingsEbayRoute
  '/settings/listing-templates': typeof SettingsListingTemplatesRoute
  '/settings/store-options': typeof SettingsStoreOptionsRoute
  '/settings/user-management': typeof SettingsUserManagementRoute
  '/shop/cart': typeof ShopCartRoute
  '/shop/inventory': typeof ShopInventoryRoute
  '/shop/join': typeof ShopJoinRoute
  '/shop/privacy': typeof ShopPrivacyRoute
  '/shop/reserve': typeof ShopReserveRoute
  '/shop/sold': typeof ShopSoldRoute
  '/shop/terms': typeof ShopTermsRoute
  '/tools/analytics': typeof ToolsAnalyticsRoute
  '/tools/breakeven': typeof ToolsBreakevenRoute
  '/tools/bundle-settings': typeof ToolsBundleSettingsRoute
  '/tools/bundle-template-edit': typeof ToolsBundleTemplateEditRoute
  '/tools/bundle-templates': typeof ToolsBundleTemplatesRoute
  '/tools/costbasis-backfill': typeof ToolsCostbasisBackfillRoute
  '/tools/deck-search': typeof ToolsDeckSearchRoute
  '/tools/deck-templates': typeof ToolsDeckTemplatesRoute
  '/tools/ebay': typeof ToolsEbayRoute
  '/tools/import': typeof ToolsImportRoute
  '/tools/intake': typeof ToolsIntakeRoute
  '/tools/leads': typeof ToolsLeadsRoute
  '/tools/listing-import': typeof ToolsListingImportRoute
  '/tools/locate': typeof ToolsLocateRoute
  '/tools/lot-analyzer': typeof ToolsLotAnalyzerRoute
  '/tools/pricetrack': typeof ToolsPricetrackRoute
  '/tools/recommendations': typeof ToolsRecommendationsRoute
  '/tools/reports': typeof ToolsReportsRoute
  '/tools/roi': typeof ToolsRoiRoute
  '/tools/scan': typeof ToolsScanRoute
  '/tools/setmanager': typeof ToolsSetmanagerRoute
  '/tools/storage-bins': typeof ToolsStorageBinsRoute
  '/tools/supplies': typeof ToolsSuppliesRoute
  '/tools/templates': typeof ToolsTemplatesRoute
  '/tools/weight': typeof ToolsWeightRoute
  '/inventory': typeof InventoryIndexRoute
  '/lots': typeof LotsIndexRoute
  '/products': typeof ProductsIndexRoute
  '/sales': typeof SalesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/shop': typeof ShopIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/sales/$id/pick': typeof SalesIdPickRoute
  '/shop/account/login': typeof ShopAccountLoginRoute
  '/shop/account/verify': typeof ShopAccountVerifyRoute
  '/shop/bundle/$id': typeof ShopBundleIdRoute
  '/shop/card/$id': typeof ShopCardIdRoute
  '/shop/r/$token': typeof ShopRTokenRoute
  '/tools/imports/new': typeof ToolsImportsNewRoute
  '/sales/$id': typeof SalesIdIndexRoute
  '/shop/account': typeof ShopAccountIndexRoute
  '/tools/imports': typeof ToolsImportsIndexRoute
  '/shop/account/reservations/$id': typeof ShopAccountReservationsIdRoute
  '/tools/imports/$id/results': typeof ToolsImportsIdResultsRoute
  '/tools/imports/$id/review': typeof ToolsImportsIdReviewRoute
  '/tools/imports/$id': typeof ToolsImportsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$door': typeof DoorRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRouteWithChildren
  '/live': typeof LiveRoute
  '/lots': typeof LotsRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/reservations': typeof ReservationsRoute
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/shop': typeof ShopRouteWithChildren
  '/tools': typeof ToolsRouteWithChildren
  '/inventory/$id': typeof InventoryIdRoute
  '/inventory/bulk': typeof InventoryBulkRoute
  '/inventory/create': typeof InventoryCreateRoute
  '/join/$token': typeof JoinTokenRoute
  '/lots/$id': typeof LotsIdRoute
  '/lots/create': typeof LotsCreateRoute
  '/lots/ebay-import': typeof LotsEbayImportRoute
  '/products/$id': typeof ProductsIdRoute
  '/products/create': typeof ProductsCreateRoute
  '/products/deck-import': typeof ProductsDeckImportRoute
  '/products/pick': typeof ProductsPickRoute
  '/products/studio': typeof ProductsStudioRoute
  '/sales/$id': typeof SalesIdRouteWithChildren
  '/sales/create': typeof SalesCreateRoute
  '/settings/account-security': typeof SettingsAccountSecurityRoute
  '/settings/bundle-defaults': typeof SettingsBundleDefaultsRoute
  '/settings/display': typeof SettingsDisplayRoute
  '/settings/ebay': typeof SettingsEbayRoute
  '/settings/listing-templates': typeof SettingsListingTemplatesRoute
  '/settings/store-options': typeof SettingsStoreOptionsRoute
  '/settings/user-management': typeof SettingsUserManagementRoute
  '/shop/account': typeof ShopAccountRouteWithChildren
  '/shop/cart': typeof ShopCartRoute
  '/shop/inventory': typeof ShopInventoryRoute
  '/shop/join': typeof ShopJoinRoute
  '/shop/privacy': typeof ShopPrivacyRoute
  '/shop/reserve': typeof ShopReserveRoute
  '/shop/sold': typeof ShopSoldRoute
  '/shop/terms': typeof ShopTermsRoute
  '/tools/analytics': typeof ToolsAnalyticsRoute
  '/tools/breakeven': typeof ToolsBreakevenRoute
  '/tools/bundle-settings': typeof ToolsBundleSettingsRoute
  '/tools/bundle-template-edit': typeof ToolsBundleTemplateEditRoute
  '/tools/bundle-templates': typeof ToolsBundleTemplatesRoute
  '/tools/costbasis-backfill': typeof ToolsCostbasisBackfillRoute
  '/tools/deck-search': typeof ToolsDeckSearchRoute
  '/tools/deck-templates': typeof ToolsDeckTemplatesRoute
  '/tools/ebay': typeof ToolsEbayRoute
  '/tools/import': typeof ToolsImportRoute
  '/tools/intake': typeof ToolsIntakeRoute
  '/tools/leads': typeof ToolsLeadsRoute
  '/tools/listing-import': typeof ToolsListingImportRoute
  '/tools/locate': typeof ToolsLocateRoute
  '/tools/lot-analyzer': typeof ToolsLotAnalyzerRoute
  '/tools/pricetrack': typeof ToolsPricetrackRoute
  '/tools/recommendations': typeof ToolsRecommendationsRoute
  '/tools/reports': typeof ToolsReportsRoute
  '/tools/roi': typeof ToolsRoiRoute
  '/tools/scan': typeof ToolsScanRoute
  '/tools/setmanager': typeof ToolsSetmanagerRoute
  '/tools/storage-bins': typeof ToolsStorageBinsRoute
  '/tools/supplies': typeof ToolsSuppliesRoute
  '/tools/templates': typeof ToolsTemplatesRoute
  '/tools/weight': typeof ToolsWeightRoute
  '/inventory/': typeof InventoryIndexRoute
  '/lots/': typeof LotsIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shop/': typeof ShopIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/sales/$id/pick': typeof SalesIdPickRoute
  '/shop/account/login': typeof ShopAccountLoginRoute
  '/shop/account/verify': typeof ShopAccountVerifyRoute
  '/shop/bundle/$id': typeof ShopBundleIdRoute
  '/shop/card/$id': typeof ShopCardIdRoute
  '/shop/r/$token': typeof ShopRTokenRoute
  '/tools/imports/$id': typeof ToolsImportsIdRouteWithChildren
  '/tools/imports/new': typeof ToolsImportsNewRoute
  '/sales/$id/': typeof SalesIdIndexRoute
  '/shop/account/': typeof ShopAccountIndexRoute
  '/tools/imports/': typeof ToolsImportsIndexRoute
  '/shop/account/reservations/$id': typeof ShopAccountReservationsIdRoute
  '/tools/imports/$id/results': typeof ToolsImportsIdResultsRoute
  '/tools/imports/$id/review': typeof ToolsImportsIdReviewRoute
  '/tools/imports/$id/': typeof ToolsImportsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$door'
    | '/dashboard'
    | '/inventory'
    | '/live'
    | '/lots'
    | '/products'
    | '/reservations'
    | '/sales'
    | '/settings'
    | '/shop'
    | '/tools'
    | '/inventory/$id'
    | '/inventory/bulk'
    | '/inventory/create'
    | '/join/$token'
    | '/lots/$id'
    | '/lots/create'
    | '/lots/ebay-import'
    | '/products/$id'
    | '/products/create'
    | '/products/deck-import'
    | '/products/pick'
    | '/products/studio'
    | '/sales/$id'
    | '/sales/create'
    | '/settings/account-security'
    | '/settings/bundle-defaults'
    | '/settings/display'
    | '/settings/ebay'
    | '/settings/listing-templates'
    | '/settings/store-options'
    | '/settings/user-management'
    | '/shop/account'
    | '/shop/cart'
    | '/shop/inventory'
    | '/shop/join'
    | '/shop/privacy'
    | '/shop/reserve'
    | '/shop/sold'
    | '/shop/terms'
    | '/tools/analytics'
    | '/tools/breakeven'
    | '/tools/bundle-settings'
    | '/tools/bundle-template-edit'
    | '/tools/bundle-templates'
    | '/tools/costbasis-backfill'
    | '/tools/deck-search'
    | '/tools/deck-templates'
    | '/tools/ebay'
    | '/tools/import'
    | '/tools/intake'
    | '/tools/leads'
    | '/tools/listing-import'
    | '/tools/locate'
    | '/tools/lot-analyzer'
    | '/tools/pricetrack'
    | '/tools/recommendations'
    | '/tools/reports'
    | '/tools/roi'
    | '/tools/scan'
    | '/tools/setmanager'
    | '/tools/storage-bins'
    | '/tools/supplies'
    | '/tools/templates'
    | '/tools/weight'
    | '/inventory/'
    | '/lots/'
    | '/products/'
    | '/sales/'
    | '/settings/'
    | '/shop/'
    | '/tools/'
    | '/sales/$id/pick'
    | '/shop/account/login'
    | '/shop/account/verify'
    | '/shop/bundle/$id'
    | '/shop/card/$id'
    | '/shop/r/$token'
    | '/tools/imports/$id'
    | '/tools/imports/new'
    | '/sales/$id/'
    | '/shop/account/'
    | '/tools/imports/'
    | '/shop/account/reservations/$id'
    | '/tools/imports/$id/results'
    | '/tools/imports/$id/review'
    | '/tools/imports/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$door'
    | '/dashboard'
    | '/live'
    | '/reservations'
    | '/inventory/$id'
    | '/inventory/bulk'
    | '/inventory/create'
    | '/join/$token'
    | '/lots/$id'
    | '/lots/create'
    | '/lots/ebay-import'
    | '/products/$id'
    | '/products/create'
    | '/products/deck-import'
    | '/products/pick'
    | '/products/studio'
    | '/sales/create'
    | '/settings/account-security'
    | '/settings/bundle-defaults'
    | '/settings/display'
    | '/settings/ebay'
    | '/settings/listing-templates'
    | '/settings/store-options'
    | '/settings/user-management'
    | '/shop/cart'
    | '/shop/inventory'
    | '/shop/join'
    | '/shop/privacy'
    | '/shop/reserve'
    | '/shop/sold'
    | '/shop/terms'
    | '/tools/analytics'
    | '/tools/breakeven'
    | '/tools/bundle-settings'
    | '/tools/bundle-template-edit'
    | '/tools/bundle-templates'
    | '/tools/costbasis-backfill'
    | '/tools/deck-search'
    | '/tools/deck-templates'
    | '/tools/ebay'
    | '/tools/import'
    | '/tools/intake'
    | '/tools/leads'
    | '/tools/listing-import'
    | '/tools/locate'
    | '/tools/lot-analyzer'
    | '/tools/pricetrack'
    | '/tools/recommendations'
    | '/tools/reports'
    | '/tools/roi'
    | '/tools/scan'
    | '/tools/setmanager'
    | '/tools/storage-bins'
    | '/tools/supplies'
    | '/tools/templates'
    | '/tools/weight'
    | '/inventory'
    | '/lots'
    | '/products'
    | '/sales'
    | '/settings'
    | '/shop'
    | '/tools'
    | '/sales/$id/pick'
    | '/shop/account/login'
    | '/shop/account/verify'
    | '/shop/bundle/$id'
    | '/shop/card/$id'
    | '/shop/r/$token'
    | '/tools/imports/new'
    | '/sales/$id'
    | '/shop/account'
    | '/tools/imports'
    | '/shop/account/reservations/$id'
    | '/tools/imports/$id/results'
    | '/tools/imports/$id/review'
    | '/tools/imports/$id'
  id:
    | '__root__'
    | '/'
    | '/$door'
    | '/dashboard'
    | '/inventory'
    | '/live'
    | '/lots'
    | '/products'
    | '/reservations'
    | '/sales'
    | '/settings'
    | '/shop'
    | '/tools'
    | '/inventory/$id'
    | '/inventory/bulk'
    | '/inventory/create'
    | '/join/$token'
    | '/lots/$id'
    | '/lots/create'
    | '/lots/ebay-import'
    | '/products/$id'
    | '/products/create'
    | '/products/deck-import'
    | '/products/pick'
    | '/products/studio'
    | '/sales/$id'
    | '/sales/create'
    | '/settings/account-security'
    | '/settings/bundle-defaults'
    | '/settings/display'
    | '/settings/ebay'
    | '/settings/listing-templates'
    | '/settings/store-options'
    | '/settings/user-management'
    | '/shop/account'
    | '/shop/cart'
    | '/shop/inventory'
    | '/shop/join'
    | '/shop/privacy'
    | '/shop/reserve'
    | '/shop/sold'
    | '/shop/terms'
    | '/tools/analytics'
    | '/tools/breakeven'
    | '/tools/bundle-settings'
    | '/tools/bundle-template-edit'
    | '/tools/bundle-templates'
    | '/tools/costbasis-backfill'
    | '/tools/deck-search'
    | '/tools/deck-templates'
    | '/tools/ebay'
    | '/tools/import'
    | '/tools/intake'
    | '/tools/leads'
    | '/tools/listing-import'
    | '/tools/locate'
    | '/tools/lot-analyzer'
    | '/tools/pricetrack'
    | '/tools/recommendations'
    | '/tools/reports'
    | '/tools/roi'
    | '/tools/scan'
    | '/tools/setmanager'
    | '/tools/storage-bins'
    | '/tools/supplies'
    | '/tools/templates'
    | '/tools/weight'
    | '/inventory/'
    | '/lots/'
    | '/products/'
    | '/sales/'
    | '/settings/'
    | '/shop/'
    | '/tools/'
    | '/sales/$id/pick'
    | '/shop/account/login'
    | '/shop/account/verify'
    | '/shop/bundle/$id'
    | '/shop/card/$id'
    | '/shop/r/$token'
    | '/tools/imports/$id'
    | '/tools/imports/new'
    | '/sales/$id/'
    | '/shop/account/'
    | '/tools/imports/'
    | '/shop/account/reservations/$id'
    | '/tools/imports/$id/results'
    | '/tools/imports/$id/review'
    | '/tools/imports/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DoorRoute: typeof DoorRoute
  DashboardRoute: typeof DashboardRoute
  InventoryRoute: typeof InventoryRouteWithChildren
  LiveRoute: typeof LiveRoute
  LotsRoute: typeof LotsRouteWithChildren
  ProductsRoute: typeof ProductsRouteWithChildren
  ReservationsRoute: typeof ReservationsRoute
  SalesRoute: typeof SalesRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  ShopRoute: typeof ShopRouteWithChildren
  ToolsRoute: typeof ToolsRouteWithChildren
  JoinTokenRoute: typeof JoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$door': {
      id: '/$door'
      path: '/$door'
      fullPath: '/$door'
      preLoaderRoute: typeof DoorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live': {
      id: '/live'
      path: '/live'
      fullPath: '/live'
      preLoaderRoute: typeof LiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lots': {
      id: '/lots'
      path: '/lots'
      fullPath: '/lots'
      preLoaderRoute: typeof LotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservations': {
      id: '/reservations'
      path: '/reservations'
      fullPath: '/reservations'
      preLoaderRoute: typeof ReservationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales': {
      id: '/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof SalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop': {
      id: '/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools': {
      id: '/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/inventory/$id': {
      id: '/inventory/$id'
      path: '/$id'
      fullPath: '/inventory/$id'
      preLoaderRoute: typeof InventoryIdRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/inventory/bulk': {
      id: '/inventory/bulk'
      path: '/bulk'
      fullPath: '/inventory/bulk'
      preLoaderRoute: typeof InventoryBulkRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/inventory/create': {
      id: '/inventory/create'
      path: '/create'
      fullPath: '/inventory/create'
      preLoaderRoute: typeof InventoryCreateRouteImport
      parentRoute: typeof InventoryRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lots/': {
      id: '/lots/'
      path: '/'
      fullPath: '/lots/'
      preLoaderRoute: typeof LotsIndexRouteImport
      parentRoute: typeof LotsRoute
    }
    '/lots/$id': {
      id: '/lots/$id'
      path: '/$id'
      fullPath: '/lots/$id'
      preLoaderRoute: typeof LotsIdRouteImport
      parentRoute: typeof LotsRoute
    }
    '/lots/create': {
      id: '/lots/create'
      path: '/create'
      fullPath: '/lots/create'
      preLoaderRoute: typeof LotsCreateRouteImport
      parentRoute: typeof LotsRoute
    }
    '/lots/ebay-import': {
      id: '/lots/ebay-import'
      path: '/ebay-import'
      fullPath: '/lots/ebay-import'
      preLoaderRoute: typeof LotsEbayImportRouteImport
      parentRoute: typeof LotsRoute
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/$id': {
      id: '/products/$id'
      path: '/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/create': {
      id: '/products/create'
      path: '/create'
      fullPath: '/products/create'
      preLoaderRoute: typeof ProductsCreateRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/deck-import': {
      id: '/products/deck-import'
      path: '/deck-import'
      fullPath: '/products/deck-import'
      preLoaderRoute: typeof ProductsDeckImportRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/pick': {
      id: '/products/pick'
      path: '/pick'
      fullPath: '/products/pick'
      preLoaderRoute: typeof ProductsPickRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/studio': {
      id: '/products/studio'
      path: '/studio'
      fullPath: '/products/studio'
      preLoaderRoute: typeof ProductsStudioRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/sales/': {
      id: '/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/$id': {
      id: '/sales/$id'
      path: '/$id'
      fullPath: '/sales/$id'
      preLoaderRoute: typeof SalesIdRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/create': {
      id: '/sales/create'
      path: '/create'
      fullPath: '/sales/create'
      preLoaderRoute: typeof SalesCreateRouteImport
      parentRoute: typeof SalesRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account-security': {
      id: '/settings/account-security'
      path: '/account-security'
      fullPath: '/settings/account-security'
      preLoaderRoute: typeof SettingsAccountSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/bundle-defaults': {
      id: '/settings/bundle-defaults'
      path: '/bundle-defaults'
      fullPath: '/settings/bundle-defaults'
      preLoaderRoute: typeof SettingsBundleDefaultsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/display': {
      id: '/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof SettingsDisplayRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/ebay': {
      id: '/settings/ebay'
      path: '/ebay'
      fullPath: '/settings/ebay'
      preLoaderRoute: typeof SettingsEbayRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/listing-templates': {
      id: '/settings/listing-templates'
      path: '/listing-templates'
      fullPath: '/settings/listing-templates'
      preLoaderRoute: typeof SettingsListingTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/store-options': {
      id: '/settings/store-options'
      path: '/store-options'
      fullPath: '/settings/store-options'
      preLoaderRoute: typeof SettingsStoreOptionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/user-management': {
      id: '/settings/user-management'
      path: '/user-management'
      fullPath: '/settings/user-management'
      preLoaderRoute: typeof SettingsUserManagementRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/shop/': {
      id: '/shop/'
      path: '/'
      fullPath: '/shop/'
      preLoaderRoute: typeof ShopIndexRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/account': {
      id: '/shop/account'
      path: '/account'
      fullPath: '/shop/account'
      preLoaderRoute: typeof ShopAccountRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/cart': {
      id: '/shop/cart'
      path: '/cart'
      fullPath: '/shop/cart'
      preLoaderRoute: typeof ShopCartRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/inventory': {
      id: '/shop/inventory'
      path: '/inventory'
      fullPath: '/shop/inventory'
      preLoaderRoute: typeof ShopInventoryRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/join': {
      id: '/shop/join'
      path: '/join'
      fullPath: '/shop/join'
      preLoaderRoute: typeof ShopJoinRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/privacy': {
      id: '/shop/privacy'
      path: '/privacy'
      fullPath: '/shop/privacy'
      preLoaderRoute: typeof ShopPrivacyRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/reserve': {
      id: '/shop/reserve'
      path: '/reserve'
      fullPath: '/shop/reserve'
      preLoaderRoute: typeof ShopReserveRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/sold': {
      id: '/shop/sold'
      path: '/sold'
      fullPath: '/shop/sold'
      preLoaderRoute: typeof ShopSoldRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/terms': {
      id: '/shop/terms'
      path: '/terms'
      fullPath: '/shop/terms'
      preLoaderRoute: typeof ShopTermsRouteImport
      parentRoute: typeof ShopRoute
    }
    '/tools/': {
      id: '/tools/'
      path: '/'
      fullPath: '/tools/'
      preLoaderRoute: typeof ToolsIndexRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/analytics': {
      id: '/tools/analytics'
      path: '/analytics'
      fullPath: '/tools/analytics'
      preLoaderRoute: typeof ToolsAnalyticsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/breakeven': {
      id: '/tools/breakeven'
      path: '/breakeven'
      fullPath: '/tools/breakeven'
      preLoaderRoute: typeof ToolsBreakevenRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/bundle-settings': {
      id: '/tools/bundle-settings'
      path: '/bundle-settings'
      fullPath: '/tools/bundle-settings'
      preLoaderRoute: typeof ToolsBundleSettingsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/bundle-template-edit': {
      id: '/tools/bundle-template-edit'
      path: '/bundle-template-edit'
      fullPath: '/tools/bundle-template-edit'
      preLoaderRoute: typeof ToolsBundleTemplateEditRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/bundle-templates': {
      id: '/tools/bundle-templates'
      path: '/bundle-templates'
      fullPath: '/tools/bundle-templates'
      preLoaderRoute: typeof ToolsBundleTemplatesRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/costbasis-backfill': {
      id: '/tools/costbasis-backfill'
      path: '/costbasis-backfill'
      fullPath: '/tools/costbasis-backfill'
      preLoaderRoute: typeof ToolsCostbasisBackfillRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/deck-search': {
      id: '/tools/deck-search'
      path: '/deck-search'
      fullPath: '/tools/deck-search'
      preLoaderRoute: typeof ToolsDeckSearchRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/deck-templates': {
      id: '/tools/deck-templates'
      path: '/deck-templates'
      fullPath: '/tools/deck-templates'
      preLoaderRoute: typeof ToolsDeckTemplatesRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/ebay': {
      id: '/tools/ebay'
      path: '/ebay'
      fullPath: '/tools/ebay'
      preLoaderRoute: typeof ToolsEbayRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/import': {
      id: '/tools/import'
      path: '/import'
      fullPath: '/tools/import'
      preLoaderRoute: typeof ToolsImportRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/intake': {
      id: '/tools/intake'
      path: '/intake'
      fullPath: '/tools/intake'
      preLoaderRoute: typeof ToolsIntakeRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/leads': {
      id: '/tools/leads'
      path: '/leads'
      fullPath: '/tools/leads'
      preLoaderRoute: typeof ToolsLeadsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/listing-import': {
      id: '/tools/listing-import'
      path: '/listing-import'
      fullPath: '/tools/listing-import'
      preLoaderRoute: typeof ToolsListingImportRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/locate': {
      id: '/tools/locate'
      path: '/locate'
      fullPath: '/tools/locate'
      preLoaderRoute: typeof ToolsLocateRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/lot-analyzer': {
      id: '/tools/lot-analyzer'
      path: '/lot-analyzer'
      fullPath: '/tools/lot-analyzer'
      preLoaderRoute: typeof ToolsLotAnalyzerRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/pricetrack': {
      id: '/tools/pricetrack'
      path: '/pricetrack'
      fullPath: '/tools/pricetrack'
      preLoaderRoute: typeof ToolsPricetrackRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/recommendations': {
      id: '/tools/recommendations'
      path: '/recommendations'
      fullPath: '/tools/recommendations'
      preLoaderRoute: typeof ToolsRecommendationsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/reports': {
      id: '/tools/reports'
      path: '/reports'
      fullPath: '/tools/reports'
      preLoaderRoute: typeof ToolsReportsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/roi': {
      id: '/tools/roi'
      path: '/roi'
      fullPath: '/tools/roi'
      preLoaderRoute: typeof ToolsRoiRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/scan': {
      id: '/tools/scan'
      path: '/scan'
      fullPath: '/tools/scan'
      preLoaderRoute: typeof ToolsScanRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/setmanager': {
      id: '/tools/setmanager'
      path: '/setmanager'
      fullPath: '/tools/setmanager'
      preLoaderRoute: typeof ToolsSetmanagerRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/storage-bins': {
      id: '/tools/storage-bins'
      path: '/storage-bins'
      fullPath: '/tools/storage-bins'
      preLoaderRoute: typeof ToolsStorageBinsRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/supplies': {
      id: '/tools/supplies'
      path: '/supplies'
      fullPath: '/tools/supplies'
      preLoaderRoute: typeof ToolsSuppliesRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/templates': {
      id: '/tools/templates'
      path: '/templates'
      fullPath: '/tools/templates'
      preLoaderRoute: typeof ToolsTemplatesRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/weight': {
      id: '/tools/weight'
      path: '/weight'
      fullPath: '/tools/weight'
      preLoaderRoute: typeof ToolsWeightRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/sales/$id/': {
      id: '/sales/$id/'
      path: '/'
      fullPath: '/sales/$id/'
      preLoaderRoute: typeof SalesIdIndexRouteImport
      parentRoute: typeof SalesIdRoute
    }
    '/sales/$id/pick': {
      id: '/sales/$id/pick'
      path: '/pick'
      fullPath: '/sales/$id/pick'
      preLoaderRoute: typeof SalesIdPickRouteImport
      parentRoute: typeof SalesIdRoute
    }
    '/shop/account/': {
      id: '/shop/account/'
      path: '/'
      fullPath: '/shop/account/'
      preLoaderRoute: typeof ShopAccountIndexRouteImport
      parentRoute: typeof ShopAccountRoute
    }
    '/shop/account/login': {
      id: '/shop/account/login'
      path: '/login'
      fullPath: '/shop/account/login'
      preLoaderRoute: typeof ShopAccountLoginRouteImport
      parentRoute: typeof ShopAccountRoute
    }
    '/shop/account/verify': {
      id: '/shop/account/verify'
      path: '/verify'
      fullPath: '/shop/account/verify'
      preLoaderRoute: typeof ShopAccountVerifyRouteImport
      parentRoute: typeof ShopAccountRoute
    }
    '/shop/bundle/$id': {
      id: '/shop/bundle/$id'
      path: '/bundle/$id'
      fullPath: '/shop/bundle/$id'
      preLoaderRoute: typeof ShopBundleIdRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/card/$id': {
      id: '/shop/card/$id'
      path: '/card/$id'
      fullPath: '/shop/card/$id'
      preLoaderRoute: typeof ShopCardIdRouteImport
      parentRoute: typeof ShopRoute
    }
    '/shop/r/$token': {
      id: '/shop/r/$token'
      path: '/r/$token'
      fullPath: '/shop/r/$token'
      preLoaderRoute: typeof ShopRTokenRouteImport
      parentRoute: typeof ShopRoute
    }
    '/tools/imports/': {
      id: '/tools/imports/'
      path: '/imports'
      fullPath: '/tools/imports/'
      preLoaderRoute: typeof ToolsImportsIndexRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/imports/$id': {
      id: '/tools/imports/$id'
      path: '/imports/$id'
      fullPath: '/tools/imports/$id'
      preLoaderRoute: typeof ToolsImportsIdRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/imports/new': {
      id: '/tools/imports/new'
      path: '/imports/new'
      fullPath: '/tools/imports/new'
      preLoaderRoute: typeof ToolsImportsNewRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/shop/account/reservations/$id': {
      id: '/shop/account/reservations/$id'
      path: '/reservations/$id'
      fullPath: '/shop/account/reservations/$id'
      preLoaderRoute: typeof ShopAccountReservationsIdRouteImport
      parentRoute: typeof ShopAccountRoute
    }
    '/tools/imports/$id/': {
      id: '/tools/imports/$id/'
      path: '/'
      fullPath: '/tools/imports/$id/'
      preLoaderRoute: typeof ToolsImportsIdIndexRouteImport
      parentRoute: typeof ToolsImportsIdRoute
    }
    '/tools/imports/$id/results': {
      id: '/tools/imports/$id/results'
      path: '/results'
      fullPath: '/tools/imports/$id/results'
      preLoaderRoute: typeof ToolsImportsIdResultsRouteImport
      parentRoute: typeof ToolsImportsIdRoute
    }
    '/tools/imports/$id/review': {
      id: '/tools/imports/$id/review'
      path: '/review'
      fullPath: '/tools/imports/$id/review'
      preLoaderRoute: typeof ToolsImportsIdReviewRouteImport
      parentRoute: typeof ToolsImportsIdRoute
    }
  }
}

interface InventoryRouteChildren {
  InventoryIdRoute: typeof InventoryIdRoute
  InventoryBulkRoute: typeof InventoryBulkRoute
  InventoryCreateRoute: typeof InventoryCreateRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
}

const InventoryRouteChildren: InventoryRouteChildren = {
  InventoryIdRoute: InventoryIdRoute,
  InventoryBulkRoute: InventoryBulkRoute,
  InventoryCreateRoute: InventoryCreateRoute,
  InventoryIndexRoute: InventoryIndexRoute,
}

const InventoryRouteWithChildren = InventoryRoute._addFileChildren(
  InventoryRouteChildren,
)

interface LotsRouteChildren {
  LotsIdRoute: typeof LotsIdRoute
  LotsCreateRoute: typeof LotsCreateRoute
  LotsEbayImportRoute: typeof LotsEbayImportRoute
  LotsIndexRoute: typeof LotsIndexRoute
}

const LotsRouteChildren: LotsRouteChildren = {
  LotsIdRoute: LotsIdRoute,
  LotsCreateRoute: LotsCreateRoute,
  LotsEbayImportRoute: LotsEbayImportRoute,
  LotsIndexRoute: LotsIndexRoute,
}

const LotsRouteWithChildren = LotsRoute._addFileChildren(LotsRouteChildren)

interface ProductsRouteChildren {
  ProductsIdRoute: typeof ProductsIdRoute
  ProductsCreateRoute: typeof ProductsCreateRoute
  ProductsDeckImportRoute: typeof ProductsDeckImportRoute
  ProductsPickRoute: typeof ProductsPickRoute
  ProductsStudioRoute: typeof ProductsStudioRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsIdRoute: ProductsIdRoute,
  ProductsCreateRoute: ProductsCreateRoute,
  ProductsDeckImportRoute: ProductsDeckImportRoute,
  ProductsPickRoute: ProductsPickRoute,
  ProductsStudioRoute: ProductsStudioRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

interface SalesIdRouteChildren {
  SalesIdPickRoute: typeof SalesIdPickRoute
  SalesIdIndexRoute: typeof SalesIdIndexRoute
}

const SalesIdRouteChildren: SalesIdRouteChildren = {
  SalesIdPickRoute: SalesIdPickRoute,
  SalesIdIndexRoute: SalesIdIndexRoute,
}

const SalesIdRouteWithChildren =
  SalesIdRoute._addFileChildren(SalesIdRouteChildren)

interface SalesRouteChildren {
  SalesIdRoute: typeof SalesIdRouteWithChildren
  SalesCreateRoute: typeof SalesCreateRoute
  SalesIndexRoute: typeof SalesIndexRoute
}

const SalesRouteChildren: SalesRouteChildren = {
  SalesIdRoute: SalesIdRouteWithChildren,
  SalesCreateRoute: SalesCreateRoute,
  SalesIndexRoute: SalesIndexRoute,
}

const SalesRouteWithChildren = SalesRoute._addFileChildren(SalesRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountSecurityRoute: typeof SettingsAccountSecurityRoute
  SettingsBundleDefaultsRoute: typeof SettingsBundleDefaultsRoute
  SettingsDisplayRoute: typeof SettingsDisplayRoute
  SettingsEbayRoute: typeof SettingsEbayRoute
  SettingsListingTemplatesRoute: typeof SettingsListingTemplatesRoute
  SettingsStoreOptionsRoute: typeof SettingsStoreOptionsRoute
  SettingsUserManagementRoute: typeof SettingsUserManagementRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountSecurityRoute: SettingsAccountSecurityRoute,
  SettingsBundleDefaultsRoute: SettingsBundleDefaultsRoute,
  SettingsDisplayRoute: SettingsDisplayRoute,
  SettingsEbayRoute: SettingsEbayRoute,
  SettingsListingTemplatesRoute: SettingsListingTemplatesRoute,
  SettingsStoreOptionsRoute: SettingsStoreOptionsRoute,
  SettingsUserManagementRoute: SettingsUserManagementRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface ShopAccountRouteChildren {
  ShopAccountLoginRoute: typeof ShopAccountLoginRoute
  ShopAccountVerifyRoute: typeof ShopAccountVerifyRoute
  ShopAccountIndexRoute: typeof ShopAccountIndexRoute
  ShopAccountReservationsIdRoute: typeof ShopAccountReservationsIdRoute
}

const ShopAccountRouteChildren: ShopAccountRouteChildren = {
  ShopAccountLoginRoute: ShopAccountLoginRoute,
  ShopAccountVerifyRoute: ShopAccountVerifyRoute,
  ShopAccountIndexRoute: ShopAccountIndexRoute,
  ShopAccountReservationsIdRoute: ShopAccountReservationsIdRoute,
}

const ShopAccountRouteWithChildren = ShopAccountRoute._addFileChildren(
  ShopAccountRouteChildren,
)

interface ShopRouteChildren {
  ShopAccountRoute: typeof ShopAccountRouteWithChildren
  ShopCartRoute: typeof ShopCartRoute
  ShopInventoryRoute: typeof ShopInventoryRoute
  ShopJoinRoute: typeof ShopJoinRoute
  ShopPrivacyRoute: typeof ShopPrivacyRoute
  ShopReserveRoute: typeof ShopReserveRoute
  ShopSoldRoute: typeof ShopSoldRoute
  ShopTermsRoute: typeof ShopTermsRoute
  ShopIndexRoute: typeof ShopIndexRoute
  ShopBundleIdRoute: typeof ShopBundleIdRoute
  ShopCardIdRoute: typeof ShopCardIdRoute
  ShopRTokenRoute: typeof ShopRTokenRoute
}

const ShopRouteChildren: ShopRouteChildren = {
  ShopAccountRoute: ShopAccountRouteWithChildren,
  ShopCartRoute: ShopCartRoute,
  ShopInventoryRoute: ShopInventoryRoute,
  ShopJoinRoute: ShopJoinRoute,
  ShopPrivacyRoute: ShopPrivacyRoute,
  ShopReserveRoute: ShopReserveRoute,
  ShopSoldRoute: ShopSoldRoute,
  ShopTermsRoute: ShopTermsRoute,
  ShopIndexRoute: ShopIndexRoute,
  ShopBundleIdRoute: ShopBundleIdRoute,
  ShopCardIdRoute: ShopCardIdRoute,
  ShopRTokenRoute: ShopRTokenRoute,
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)

interface ToolsImportsIdRouteChildren {
  ToolsImportsIdResultsRoute: typeof ToolsImportsIdResultsRoute
  ToolsImportsIdReviewRoute: typeof ToolsImportsIdReviewRoute
  ToolsImportsIdIndexRoute: typeof ToolsImportsIdIndexRoute
}

const ToolsImportsIdRouteChildren: ToolsImportsIdRouteChildren = {
  ToolsImportsIdResultsRoute: ToolsImportsIdResultsRoute,
  ToolsImportsIdReviewRoute: ToolsImportsIdReviewRoute,
  ToolsImportsIdIndexRoute: ToolsImportsIdIndexRoute,
}

const ToolsImportsIdRouteWithChildren = ToolsImportsIdRoute._addFileChildren(
  ToolsImportsIdRouteChildren,
)

interface ToolsRouteChildren {
  ToolsAnalyticsRoute: typeof ToolsAnalyticsRoute
  ToolsBreakevenRoute: typeof ToolsBreakevenRoute
  ToolsBundleSettingsRoute: typeof ToolsBundleSettingsRoute
  ToolsBundleTemplateEditRoute: typeof ToolsBundleTemplateEditRoute
  ToolsBundleTemplatesRoute: typeof ToolsBundleTemplatesRoute
  ToolsCostbasisBackfillRoute: typeof ToolsCostbasisBackfillRoute
  ToolsDeckSearchRoute: typeof ToolsDeckSearchRoute
  ToolsDeckTemplatesRoute: typeof ToolsDeckTemplatesRoute
  ToolsEbayRoute: typeof ToolsEbayRoute
  ToolsImportRoute: typeof ToolsImportRoute
  ToolsIntakeRoute: typeof ToolsIntakeRoute
  ToolsLeadsRoute: typeof ToolsLeadsRoute
  ToolsListingImportRoute: typeof ToolsListingImportRoute
  ToolsLocateRoute: typeof ToolsLocateRoute
  ToolsLotAnalyzerRoute: typeof ToolsLotAnalyzerRoute
  ToolsPricetrackRoute: typeof ToolsPricetrackRoute
  ToolsRecommendationsRoute: typeof ToolsRecommendationsRoute
  ToolsReportsRoute: typeof ToolsReportsRoute
  ToolsRoiRoute: typeof ToolsRoiRoute
  ToolsScanRoute: typeof ToolsScanRoute
  ToolsSetmanagerRoute: typeof ToolsSetmanagerRoute
  ToolsStorageBinsRoute: typeof ToolsStorageBinsRoute
  ToolsSuppliesRoute: typeof ToolsSuppliesRoute
  ToolsTemplatesRoute: typeof ToolsTemplatesRoute
  ToolsWeightRoute: typeof ToolsWeightRoute
  ToolsIndexRoute: typeof ToolsIndexRoute
  ToolsImportsIdRoute: typeof ToolsImportsIdRouteWithChildren
  ToolsImportsNewRoute: typeof ToolsImportsNewRoute
  ToolsImportsIndexRoute: typeof ToolsImportsIndexRoute
}

const ToolsRouteChildren: ToolsRouteChildren = {
  ToolsAnalyticsRoute: ToolsAnalyticsRoute,
  ToolsBreakevenRoute: ToolsBreakevenRoute,
  ToolsBundleSettingsRoute: ToolsBundleSettingsRoute,
  ToolsBundleTemplateEditRoute: ToolsBundleTemplateEditRoute,
  ToolsBundleTemplatesRoute: ToolsBundleTemplatesRoute,
  ToolsCostbasisBackfillRoute: ToolsCostbasisBackfillRoute,
  ToolsDeckSearchRoute: ToolsDeckSearchRoute,
  ToolsDeckTemplatesRoute: ToolsDeckTemplatesRoute,
  ToolsEbayRoute: ToolsEbayRoute,
  ToolsImportRoute: ToolsImportRoute,
  ToolsIntakeRoute: ToolsIntakeRoute,
  ToolsLeadsRoute: ToolsLeadsRoute,
  ToolsListingImportRoute: ToolsListingImportRoute,
  ToolsLocateRoute: ToolsLocateRoute,
  ToolsLotAnalyzerRoute: ToolsLotAnalyzerRoute,
  ToolsPricetrackRoute: ToolsPricetrackRoute,
  ToolsRecommendationsRoute: ToolsRecommendationsRoute,
  ToolsReportsRoute: ToolsReportsRoute,
  ToolsRoiRoute: ToolsRoiRoute,
  ToolsScanRoute: ToolsScanRoute,
  ToolsSetmanagerRoute: ToolsSetmanagerRoute,
  ToolsStorageBinsRoute: ToolsStorageBinsRoute,
  ToolsSuppliesRoute: ToolsSuppliesRoute,
  ToolsTemplatesRoute: ToolsTemplatesRoute,
  ToolsWeightRoute: ToolsWeightRoute,
  ToolsIndexRoute: ToolsIndexRoute,
  ToolsImportsIdRoute: ToolsImportsIdRouteWithChildren,
  ToolsImportsNewRoute: ToolsImportsNewRoute,
  ToolsImportsIndexRoute: ToolsImportsIndexRoute,
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DoorRoute: DoorRoute,
  DashboardRoute: DashboardRoute,
  InventoryRoute: InventoryRouteWithChildren,
  LiveRoute: LiveRoute,
  LotsRoute: LotsRouteWithChildren,
  ProductsRoute: ProductsRouteWithChildren,
  ReservationsRoute: ReservationsRoute,
  SalesRoute: SalesRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  ShopRoute: ShopRouteWithChildren,
  ToolsRoute: ToolsRouteWithChildren,
  JoinTokenRoute: JoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
